export default (theme) => ({
    chartWrapper: {
        position: 'relative',
        height: '100%',
    },
});
